import React from 'react';
import SvgIcon from './SvgIcon';

const AirPollution = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M3.5 23.427l4-3.927M8.5 23.5l4-4M13.5 23.5l4-4M12.5 13v1.5M10.5 14.5v-1.876a3.37 3.37 0 01-2-3.124 4 4 0 018 0 3.37 3.37 0 01-2 3.123V14.5M13.75 9a.25.25 0 01.25.25M13.5 9.25a.25.25 0 01.25-.25M13.75 9.5a.25.25 0 01-.25-.25M14 9.25a.25.25 0 01-.25.25M11.25 9a.25.25 0 01.25.25M11 9.25a.25.25 0 01.25-.25M11.25 9.5a.25.25 0 01-.25-.25M11.5 9.25a.25.25 0 01-.25.25"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.306 9.141a3.5 3.5 0 00-3.649-4.623A6 6 0 006 6.5a5.5 5.5 0 000 11h13a4.47 4.47 0 004.5-4.485 4.518 4.518 0 00-2.194-3.874v0z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

AirPollution.displayName = 'AirPollutionIcon';

export default AirPollution;
